export function formatCurrency(value: number | string | null | undefined): string {
  const numeric = typeof value === 'string' ? Number(value) : value ?? 0;
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(numeric);
}

export function formatDateTime(value: string): string {
  return new Intl.DateTimeFormat('it-IT', {
    dateStyle: 'medium',
    timeStyle: 'short'
  }).format(new Date(value));
}

export function secondsUntil(value: string): number {
  return Math.max(0, Math.floor((new Date(value).getTime() - Date.now()) / 1000));
}

export function formatDuration(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
  const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, '0');
  const seconds = Math.floor(totalSeconds % 60).toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}

export function participantLabel(profile?: { display_name?: string | null; nickname?: string | null } | null): string {
  return profile?.display_name || profile?.nickname || 'Utente';
}

export function copyToClipboard(text: string): Promise<void> {
  if (!navigator.clipboard) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
    return Promise.resolve();
  }
  return navigator.clipboard.writeText(text);
}
